import { render, staticRenderFns } from "./GovernmentDashboard.vue?vue&type=template&id=3fd6f479&"
import script from "./GovernmentDashboard.vue?vue&type=script&lang=js&"
export * from "./GovernmentDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports